import { GetVibrationSpecialString, MeasureHighKind } from '../../../Constant';
import { FFT_CMP_GROUP_SET, MeasureSelectItem } from '../../../function/GroupDataModel';

export type MeasureInfoType = {
  AiCard: number;
  AiCh: number;
  DevIndex: number;
  DevName: string;
  DevNo: string;
  FftInvalid: number;
  EntryNo: number;
  ItemName: string;
  ItemNameNo: number;
  KindNo: number;
  LogStart: string;
  MesName: string;
  PlcNo: number;
  SetNo: number;
  Speed: number;

  selectDay: string;
  selectTime: string;
  name: string;
  id: number;
};

export type SelectDataType = {
  mesid: number;
  devid: number;
  itemid: number;
  selectDate: Date;
  selectTime: string;
  //itemName: string;	//計測データ１～３ラベル表示
  lineColor: string;
  isSelect: boolean;
  isShow: boolean;
  isThreshold: boolean;
  envelopeNo: number;
  lineNo: number;
}


export type JudgeSettingType = {
  PLCNo: string;
  AICardNo: string;
  ChannelNo: string;
  //診断タイプ
  JudgeTypeName: string;
  //周波数　下限
  FrequencyLower: string;
  //周波数　上限
  FrequencyUpper: string;
  //演算方法
  OperationProcess: string;
  //軽故障
  MinorFailure: string;
  //重故障
  SeriousFailure: string;
  //異常種別
  AbnormalKind: string;
  //演算No
  ClcTypeNo: number;
  //裕度
  BandValue: number;
  //中心周波数
  FreqCenter: number;
  //演算種別ID
  MclcTypeID: number;
}

export type GraphLineDataType = {
  XValues: string[],
  YValues: number[],
  YValuesString: string[],
  //Y 軸最大値を取得または設定します。
  ValueMax: number,
  //Y 軸最小値を取得または設定します。
  ValueMin: number,
  PLCNo: string,
  AICardNo: string,
  ChannelNo: string,
  //機器INDEX
  MachineIndex: string,
  //機器No
  MachineNo: string,
  //機器名称
  MachineName: string,
  //項目名称
  ItemName: string,
  //エンベロープ項目
  EnveNameNo: number,
  //データ時刻
  GraphDataTime: Date,
  //開始位置
  StartIndex: string,
  //信号点数
  SignalCount: number,
  //サイズ
  SignalSize: number,
  //サンプリング周期
  SampleSpan: number,
  //ユニット
  Unit: string,
  /**
   * OA値
   * TRD_DAT_OAVからファイル時間で抽出。
   */
  OAValue: string,
  //判定値情報
  JudgeSettingModel: JudgeSettingType[];
  //インバータ駆動フラグにチェックがある場合の周波数
  TrddatChrModels: TrddatChrModel[];
  //インバータ駆動
  INV_DRV_ON: number;
  //ライン番号
  lineNo: number;
}

/**
 * 側帯波診断 表示パラメータ
 */
export type SideBandParam = {
  /**
   * 理論計算値 f
   */
  Freq: string,
  /**
   * 理論計算値 すべり(%)
   */
  Slide: string,
  /**
   * 理論計算値 2sf
   */
  BandWidth: string,
  /**
   * 理論計算値 -側
   */
  LowerSideBand: string,
  /**
   * 理論計算値 +側
   */
  UpperSideBand: string,
  /**
   * f 周波数
   */
  DBFreq: string,
  /**
   * f dB値
   */
  DBValue: string,
}

/**
 * 側帯波診断 計算結果
 */
export type SideBandCalc =
  {
    /**
     * ー側 周波数
     */
    FreqMinus: string,
    /**
     * ー側 dB値
     */
    DBMinus: string,
    /**
     * ー側 差分dB値
     */
    DBDiffMinus: string,
    /**
     * ＋側 周波数
     */
    FreqPlus: string,
    /**
     * ＋側 dB値
     */
    DBPlus: string,
    /**
     * ＋側 差分dB値
     */
    DBDiffPlus: string,
  }

/**
 * X軸 初期値
 */
export type FFTGraphInitialWidth =
  {
    /**
     * X軸最小値 初期値
     */
    XMinInitial: number,
    /**
     * X軸最大値 初期値
     */
    XMaxInitial: number,
  }
/**
 * インバータ駆動フラグがONの際に使用
 */
export type TrddatChrModel = {
  LOG_DATE: Date,
  COL_DATE: Date,
  PLC_NO: number,
  TYP_NO: number,
  MCLC_TYP_ID: number,
  FREQ?: number,
}

export const CreateDefalutMeasureInfoType = (): MeasureInfoType => {

  var dt: MeasureInfoType =
  {
    AiCard: 0,
    AiCh: 0,
    DevIndex: 0,
    DevName: "",
    DevNo: "",
    FftInvalid: 0,
    EntryNo: 0,
    ItemName: "",
    ItemNameNo: 0,
    KindNo: 0,
    LogStart: "",
    MesName: "",
    PlcNo: 0,
    SetNo: 0,
    Speed: 0,

    selectDay: "",
    selectTime: "",
    name: "",
    id: -1,
  };
  return dt;
}

export const CreateDefalutGraphLineDataType = (): GraphLineDataType => {

  var dt: GraphLineDataType =
  {
    XValues: [],
    YValues: [],
    YValuesString: [],
    ValueMax: 0,
    ValueMin: 0,
    PLCNo: '',
    AICardNo: '',
    ChannelNo: '',
    MachineIndex: '',
    MachineNo: '',
    MachineName: '',
    ItemName: '',
    EnveNameNo: 0,
    GraphDataTime: new Date(),
    StartIndex: '',
    SignalCount: 0,
    SignalSize: 0,
    SampleSpan: 0,
    Unit: '',
    OAValue: "",
    JudgeSettingModel: [],
    TrddatChrModels: [],
    INV_DRV_ON: 0,
    lineNo: 0,
  };
  return dt;
}

/**
 *
 * @param itemName 計測データ１～３ラベル表示 未使用
 * @param lineColor
 * @returns
 */
export const CreateDefalutSelectDataType = (itemName: string, lineColor: string, lineNo: number): SelectDataType => {
  var dt: SelectDataType =
  {
    devid: -1,
    mesid: -1,
    itemid: -1,
    selectDate: new Date(),
    selectTime: '',
    //itemName: itemName,
    lineColor: lineColor,
    isSelect: false,
    isThreshold: false,
    isShow: true,
    envelopeNo: 0,
    lineNo: lineNo,
  };
  return dt;
}

/**
 * 速度と変位の対応
 * @returns
 */
export const GetComparisonNo = (target?: MeasureInfoType): string => {
  var comparisonNo = '0';
  if (target?.KindNo == MeasureHighKind.VIBRATION_SPD) {
    comparisonNo = String(MeasureHighKind.VIBRATION_SPD);
  } else if (target?.KindNo == MeasureHighKind.VIBRATION_DSP) {
    comparisonNo = String(MeasureHighKind.VIBRATION_DSP);
  }
  return comparisonNo
}

/**
 * 計測リストに付加情報追加
 */
export const GetAdditionalMeasureInfoType = (translation: any, target?: MeasureInfoType[]): MeasureInfoType[] => {
  if (target == null) {
    return [];
  }
  //番号付与
  for (let i = 0; i < target.length; i++) {
    target[i].id = i + 1;
  }

  //特殊機器追加
  var copys = target.filter((r) => r.Speed == 2 && r.KindNo == 1);
  if (copys != null) {
    for (var i in copys) {
      var test1 = Object.assign(CreateDefalutMeasureInfoType(), copys[i]);
      test1.KindNo = MeasureHighKind.VIBRATION_SPD;
      test1.MesName = GetVibrationSpecialString(test1.KindNo, translation);
      test1.id = target.length + 1;
      target.push(test1);
      var test2 = Object.assign(CreateDefalutMeasureInfoType(), copys[i]);
      test2.KindNo = MeasureHighKind.VIBRATION_DSP;
      test2.MesName = GetVibrationSpecialString(test2.KindNo, translation);
      test2.id = target.length + 1;
      target.push(test2);
      //console.debug(['mesRt,test1,test2,mesRet', test1, test2, target]);
    }
  }
  //空行対応の為、デフォルト値を追加
  target.push(CreateDefalutMeasureInfoType());

  return target;
};

/**
 * 計測リストから、指定したグループデータと一致する計測データを取得
 * @param measureList 計測リスト
 * @param groupRow　選択グループアイテム
 * @param itemIndex　ライン番号画面で表示できる3本のうちのどれなのかを指定
 * @returns
 */
export const FindMeasureInfoType =
  (measureList: MeasureInfoType[], groupRow: FFT_CMP_GROUP_SET, itemIndex: number)
    : MeasureInfoType | undefined => {

    var plcNo = 0;
    var setNo = 0;
    var kindInfo = 0;
    var kindNo = 0;

    //ライン番号によって取得するカラムを変更
    switch (itemIndex) {
      case 1:
        kindInfo = groupRow.KIND1;
        plcNo = groupRow.PLC_NO1;
        setNo = groupRow.SET_NO1;
        break;
      case 2:
        kindInfo = groupRow.KIND2;
        plcNo = groupRow.PLC_NO2;
        setNo = groupRow.SET_NO2;
        break;
      case 3:
        kindInfo = groupRow.KIND3;
        plcNo = groupRow.PLC_NO3;
        setNo = groupRow.SET_NO3;
        break;
      default:
        kindInfo = groupRow.KIND3;
        plcNo = 0;
        setNo = 0;
    }

    var ret: MeasureInfoType | undefined = undefined;
    //対象データ検索
    //特殊データの場合KindNoを特殊データに入れ替えて検索
    switch (kindInfo) {
      case 1:
        kindNo = MeasureHighKind.VIBRATION_SPD;
        ret = measureList.find((item) => item.PlcNo === plcNo && item.SetNo === setNo && item.KindNo === kindNo);
        break;
      case 2:
        kindNo = MeasureHighKind.VIBRATION_DSP;
        ret = measureList.find((item) => item.PlcNo === plcNo && item.SetNo === setNo && item.KindNo === kindNo);
        break;
      default:
        ret = measureList.find((item) => item.PlcNo === plcNo && item.SetNo === setNo && item.SetNo === setNo);
        break;

    }
    return ret;
  };

export const GetMeasureInfoType = (): Promise<MeasureInfoType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/MeasuleInfo")
      .then((res) => res.json())
      .then((result: MeasureInfoType[]) => {
        if (MeasureInfoTypeListValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

const MeasureInfoTypeListValidate = (data: MeasureInfoType[]) => {

  if (data === undefined) return false;

  return true;
};

/**
 * CSVファイルの存在する時間リストを取得,
 * 失敗しても””を返す
 * @param plcNo 
 * @param aiNo 
 * @param chNo 
 * @param targetDay 
 * @param comparisonNo 
 * @param envelopeNo 
 * @returns 
 */
export const GetDataTimeList = (plcNo: number, aiNo: number, chNo: number, targetDay: string, comparisonNo: string, envelopeNo: number): Promise<string[]> => {

  const url = `api/FFTDataInfo/GetDataTimeList?plcNo=${plcNo}&&aiCardNo=${aiNo}&&channelNo=${chNo}&&targetTime=${targetDay}&&comparisonNo=${comparisonNo}&&envelopeNo=${envelopeNo}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: string[]) => {
        if (DataTimeListValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.error(`error : ${error}`);
          reject(error);
        }
      );
  });
};
const DataTimeListValidate = (data: string[]) => {

  if (data === undefined) return false;

  return true;
};

/**
 * 最新の時間を取得
 * @param plcNo
 * @param aiCardNo
 * @param channelNo
 * @param comparisonNo
 * @returns
 */
export const GetLatesTime = (envelopeNo: number, plcNo?: number, aiCardNo?: number, channelNo?: number, comparisonNo?: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const url = `api/FFTDataInfo/GetDataLatestTime?plcNo=${plcNo}&&aiCardNo=${aiCardNo}&&channelNo=${channelNo}&&comparisonNo=${comparisonNo}&&envelopeNo=${envelopeNo}`;
    console.debug(url);
    fetch(url)
      .then((res) => res.json())
      .then((result: string) => {
        console.debug(result);
        if (LatesTimeValidate(result)) resolve(result);
        resolve("");
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          resolve("");
        }
      );
  });
};

const LatesTimeValidate = (data: string) => {
  console.debug("LatesTimeValidate ckeck");
  if (data === undefined) return false;

  return true;
};


export const GetJudgeSetting = (plcNo: number, aiNo: number, chNo: number): Promise<JudgeSettingType[]> => {

  const url = `api/JudgeSettingModels/${plcNo}/${aiNo}/${chNo}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: JudgeSettingType[]) => {
        console.debug(["GetJudgeSetting fetch", result]);
        if (JudgeSettingValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
const JudgeSettingValidate = (data: JudgeSettingType[]) => {

  if (data === undefined) return false;

  return true;
};

/**
 * FFTデータ取得処理
 * @param plcNo 
 * @param aiNo 
 * @param chNo 
 * @param targetDay 
 * @param comparisonNo 
 * @param envelopeNo 
 * @returns 
 */
export const GetChartData = (plcNo: number, aiNo: number, chNo: number, targetDay: string, comparisonNo: string, envelopeNo: number): Promise<GraphLineDataType> => {
  console.debug(["envelopeNo", envelopeNo]);
  const url = `api/FFTDataInfo/GetGraphLineData?plcNo=${plcNo}&&aiCardNo=${aiNo}&&channelNo=${chNo}&&targetTime=${targetDay}&&comparisonNo=${comparisonNo}&&envelopeNo=${envelopeNo}`;
  console.debug(["url: ", url]);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: GraphLineDataType) => {
        //console.debug(["GetChartData result", result]);
        if (GetChartDataValidate(result)) resolve(result);
        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};
const GetChartDataValidate = (data: GraphLineDataType) => {

  if (data === undefined) return false;

  return true;
};
/**
 * 側帯波診断 初期画面表示パラメータ取得
 * @param plcNo 
 * @param aiNo 
 * @param chNo 
 * @param targetDay 
 * @returns 
 */
export const GetSideBandParam = (plcNo: number, aiNo: number, chNo: number, targetDay: string): Promise<SideBandParam> => {
  const url = `api/FFTDataInfo/GetSidebandParam?plcNo=${plcNo}&&aiCardNo=${aiNo}&&channelNo=${chNo}&&targetTime=${targetDay}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: SideBandParam) => {
        if (GetSideBandParamValidate(result)) resolve(result);
        reject('Invalidate response');
      })
      .catch(reason => {
        console.log(reason);
        reject(reason);
      });
  });
}
const GetSideBandParamValidate = (data: SideBandParam) => {

  if (data === undefined) return false;

  return true;
}
/**
 * 側帯波診断 計算結果取得
 * @param plcNo 
 * @param aiNo 
 * @param chNo 
 * @param targetDay 
 * @param band 
 * @returns 
 */
export const GetSideBandCalc = (plcNo: number, aiNo: number, chNo: number, targetDay: string, band: number): Promise<SideBandCalc> => {
  const url = `api/FFTDataInfo/GetSidebandCalc?plcNo=${plcNo}&&aiCardNo=${aiNo}&&channelNo=${chNo}&&targetTime=${targetDay}&&band=${band}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: SideBandCalc) => {
        if (GetSideBandCalcValidate(result)) resolve(result);
        reject('Invalidate response');
      })
      .catch(reason => {
        console.log(reason);
        reject(reason);
      });
  });
}
const GetSideBandCalcValidate = (data: SideBandCalc) => {

  if (data === undefined) return false;

  return true;
}

/**
 * FFTグラフの横軸初期値取得処理
 * @param groupNo 
 * @returns 
 */
export const GetFFTInitialWidth = (groupNo: number): Promise<FFTGraphInitialWidth> => {
  const url = `api/FFTDataInfo/GetFFTInitialWidth?groupNo=${groupNo}`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.json())
      .then((result: FFTGraphInitialWidth) => {
        console.debug(['GetFFTInitialWidth responce', result]);
        if (GetFFTInitialWidthValidate(result)) resolve(result);
        reject('Invalidate response');
      })
      .catch(reason => {
        console.log(reason);
        reject(reason);
      });
  });
}
const GetFFTInitialWidthValidate = (data: FFTGraphInitialWidth) => {

  if (data === undefined) return false;

  return true;
}